import React, { useEffect } from 'react';
import { Button, DynamicForm } from 'components';
import useFormHandler from 'hooks/useFormHandler';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';
import useApi from 'hooks/useApi';
import endpoints from 'constants/endpoints';

const EditionPositionModal = ({ closing, onClose, params }: Props) => {
  const formHandler = useFormHandler(schema);
  const api = useApi();

  useEffect(() => {
    api.fetchData(endpoints.GET_POSITION.get(params));
  }, []);

  useEffect(() => {
    if (api.response) {
      const data = {
        id: api.response.data.id,
        name: api.response.data.name,
        description: api.response.data.description,
        levelAccess: api.response.data.level_access.toString()
      };

      formHandler.setFullForm(data);
    }
  }, [api.response]);

  return (
    <Base
      header="Edit position"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button
          text="Create"
          disabled={!formHandler.valid || formHandler.isSubmitting}
          onClick={() => {
            formHandler.setIsSubmitting(true);
            onClose({ ...formHandler.data, levelAccess: +formHandler.data.levelAccess });
          }}
        />
      }
    >
      <div className="modal-create-position">
        <DynamicForm handler={formHandler} />
      </div>
    </Base>
  );
};

export default EditionPositionModal;
